"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.voltageLevelOptions = exports.transmissionZoneOptions = exports.supplySourceOptions = exports.statusOptions = exports.sourceOptions = exports.rowsPerPageOptions = exports.localityOptions = exports.columns = exports.buildingTypeOptions = void 0;
var statusOptions = [
    { key: "all", label: "All" },
    { key: "active", label: "Active" },
    { key: "inactive", label: "Inactive" },
];
exports.statusOptions = statusOptions;
var buildingTypeOptions = [
    { key: "all", label: "All Types" },
    { key: "RESIDENTIAL", label: "Residential" },
    { key: "COMMERCIAL", label: "Commercial" },
    { key: "INDUSTRIAL", label: "Industrial" },
    { key: "MIXED_USE", label: "Mixed Use" },
    { key: "RETAIL", label: "Retail" },
    { key: "MINING", label: "Mining" },
    { key: "HOTELS", label: "Hotels" },
    { key: "SPORT_CENTRES", label: "Sport Centres" },
    { key: "OFFICE", label: "Office" },
    { key: "HOTEL", label: "Hotel" },
];
exports.buildingTypeOptions = buildingTypeOptions;
var rowsPerPageOptions = [
    { key: "5", label: "5" },
    { key: "10", label: "10" },
    { key: "25", label: "25" },
    { key: "50", label: "50" },
    { key: "100", label: "100" },
];
exports.rowsPerPageOptions = rowsPerPageOptions;
var columns = [
    { name: "NAME", uid: "name" },
    { name: "CODE", uid: "code" },
    { name: "BUILDING OWNER", uid: "ownerName" },
    { name: "DESCRIPTION", uid: "description" },
    { name: "BUILDING TYPE", uid: "type" },
    { name: "SOURCE", uid: "source" },
    { name: "BILLING DATE", uid: "defaultBillingDate" },
    { name: "STATUS", uid: "status" },
    { name: "CREATED", uid: "createdAt" },
    { name: "UPDATED", uid: "updatedAt" },
    { name: "ACTIONS", uid: "actions" },
];
exports.columns = columns;
var sourceOptions = [
    { key: "MANUAL", label: "Manual" },
    { key: "IMPORT", label: "Import" },
    { key: "API", label: "API" },
    { key: "DIGITAL_TWIN", label: "API" },
];
exports.sourceOptions = sourceOptions;
var localityOptions = [
    { key: "URBAN", label: "Urban" },
    { key: "RURAL", label: "Rural" },
];
exports.localityOptions = localityOptions;
var transmissionZoneOptions = [
    { key: "0-300km", label: "0-300km" },
    { key: "301-600km", label: "301-600km" },
    { key: "601-900km", label: "601-900km" },
    { key: ">900km", label: ">900km" },
];
exports.transmissionZoneOptions = transmissionZoneOptions;
var voltageLevelOptions = [
    { key: "<500V", label: "<500V" },
    { key: ">=500V and <66kV", label: ">=500V and <66kV" },
    { key: ">=66kV and <=132kV", label: ">=66kV and <=132kV" },
    { key: ">132kV", label: ">132kV" },
];
exports.voltageLevelOptions = voltageLevelOptions;
var supplySourceOptions = [
    { key: "ESKOM", label: "Eskom" },
    { key: "MUNICIPALITY", label: "Municipality" },
    { key: "THIRD_PARTY", label: "Third Party" },
    { key: "IN_HOUSE", label: "In-House" },
    { key: "CUSTOM", label: "Custom" },
];
exports.supplySourceOptions = supplySourceOptions;
